import { render } from "./pricingpage.vue?vue&type=template&id=3148e434&scoped=true"
import script from "./pricingpage.vue?vue&type=script&lang=js"
export * from "./pricingpage.vue?vue&type=script&lang=js"

import "./pricingpage.vue?vue&type=style&index=0&id=3148e434&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3148e434"]])

export default __exports__